import { Text } from '@frontend/ui-library';
import { PropsWithChildren } from 'react';

import useCountdown from '../../hooks/useCountdown';
import { hoursInMs, months } from '../../utils';

export interface ExpirationTextProps {
  className?: string;
  endDate: number;
}

export default function ExpirationText({
  className,
  endDate,
}: PropsWithChildren<ExpirationTextProps>): JSX.Element {
  const { hours, minutes, seconds } = useCountdown({
    endDate: endDate,
  });

  const lowerThanDay = Math.floor((endDate - Date.now()) / hoursInMs) < 24;

  const date = new Date(endDate);

  const text = lowerThanDay
    ? `${hours}:${minutes}:${seconds}`
    : `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;

  return (
    <Text className={className} size="tiny" color="inherit" weight="600" data-test-id="paymentExpirationText">
      Payment expiration: {text}
    </Text>
  );
}
